import { render, staticRenderFns } from "./CmgPreConfiguredMealCard.vue?vue&type=template&id=36f20d19&scoped=true&lang=pug"
import script from "./cmg-preconfigured-meal-card.ts?vue&type=script&lang=ts&external"
export * from "./cmg-preconfigured-meal-card.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgPreConfiguredMealCard.vue?vue&type=style&index=0&id=36f20d19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f20d19",
  null
  
)

export default component.exports